<template>
  <div class="col-xs-12 col-md-3">
    <div class="form-group has-error">
      <label class="control-label">{{ label }}</label>
      <p class="form-control-static text-danger"><strong>Componente não configurado</strong></p>
    </div>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-protocolo-default",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend("minWords", {
      getMessage: (field, args) => {
        return `O campo requer ao menos ${args[0]} palavras`;
      },
      validate: (value, args) => {
        const length = value.match(/\b\w+\b/g).length;
        let result = length >= args[0];

        return result;
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Default.vue